import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M21.53 2.47a.75.75 0 0 1 0 1.06l-5.72 5.72H20a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75V4a.75.75 0 0 1 1.5 0v4.19l5.72-5.72a.75.75 0 0 1 1.06 0M3.25 14a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0v-4.19l-5.72 5.72a.75.75 0 0 1-1.06-1.06l5.72-5.72H4a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }